import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// local dependency
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { infoPill as InfoPill } from 'ui/views/generic/infoPill';
 *
 * // render
 * <InfoPill propName='propValue'/>
 */
export const infoPill = ( props ) => {

    const iconId = props.iconId ? props.iconId : 'error';
     
    const infoPillClassNames = classnames( props.className, 'ui-info-pill' );
    return (
        <div className = { infoPillClassNames }>

            {/* icon */}
            <div className='ui-info-pill__info-section'>
                <Icon id={iconId} width = { 15 } height = { 15 } />
            </div>

            {/* text */}
            <div className='ui-info-pill__text-section'>
                <p
                    className='ui-info-pill__text-section__text'
                    dangerouslySetInnerHTML = { {
                        __html: props.value
                    } }
                />
            </div>
        </div>
    );
};

// set display name
infoPill.displayName = 'infoPill';

// set default props
infoPill.defaultProps = {
    className: '',
    size: 'default',
    value: '',
};

// prop types
infoPill.propTypes = {
    className: PropTypes.string,
    size: PropTypes.string,
    value: PropTypes.any,
};
